import { Overlay, OverlayContainer } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MAT_EXPANSION_PANEL_DEFAULT_OPTIONS } from "@angular/material/expansion";
import { MatButtonModule } from "@angular/material/button";
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from "@angular/material/button-toggle";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS } from "@angular/material/slide-toggle";
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from "@angular/material/paginator";
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar } from "@angular/material/snack-bar";
import { EneIconModule } from "src/app/shared/ui/icon/legacy/icon.module";
import { TranslateModule } from "@ngx-translate/core";
import { LocaleCode } from "src/app/common/enums/locale-code";
import { datepickerDefaultFormats } from "./datepicker-formats/datepicker-formats";
import { dialogDefaultOptions } from "./dialog/dialog-options";
import { DynamicOverlay } from "./dynamic-overlay/dynamic-overlay";
import { DynamicOverlayContainer } from "./dynamic-overlay/dynamic-overlay-container";
import { expansionPanelDefaultOptions } from "./expansion-panel/expansion-panel";
import { buttonToggleDefaultOptions } from "./button-toggle/button-toggle-options";
import { formFieldDefaultOptions } from "./form-field/form-field-options";
import { slideToggleDefaultOptions } from "./slide-toggle/slide-toggle-options";
import { paginatorDefaultOptions } from "./paginator/paginator-options";
import { selectDefaultOptions } from "./select/select-options";
import { DynamicSnackBar } from "./snack-bar/snack-bar";
import { snackBarDefaultOptions } from "./snack-bar/snack-bar-options";
import { SnackBarComponent } from "./snack-bar/snack-bar.component";

@NgModule({
  declarations: [SnackBarComponent],
  imports: [CommonModule, MatButtonModule, EneIconModule, TranslateModule],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: dialogDefaultOptions },
    { provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS, useValue: expansionPanelDefaultOptions },
    { provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, useValue: buttonToggleDefaultOptions },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: formFieldDefaultOptions },
    { provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, useValue: slideToggleDefaultOptions },
    { provide: MAT_PAGINATOR_DEFAULT_OPTIONS, useValue: paginatorDefaultOptions },
    { provide: MAT_SELECT_CONFIG, useValue: selectDefaultOptions },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: snackBarDefaultOptions },
    { provide: MAT_DATE_FORMATS, useValue: datepickerDefaultFormats },
    { provide: MAT_DATE_LOCALE, useValue: LocaleCode.de_DE },
    { provide: MatSnackBar, useExisting: DynamicSnackBar },
    { provide: Overlay, useExisting: DynamicOverlay },
    { provide: OverlayContainer, useExisting: DynamicOverlayContainer }
  ]
})
export class AppMaterialModule {}
